export default __webpack_public_path__ + "static/media/CodeScene.e55497ba.png";